// export const apiUrl = 'https://khic2020-api-dev.codics.solutions/api';
// export const apiUrl = 'https://khachaturian-comp-api.codics.solutions/api';
export const apiUrl = 'https://api.khachaturian-competition.com/api';

export const round = 1;
